export default [
  {
    path: '/import/user',
    name: 'Import Tracks User',
    component: () =>
      import(/* webpackChunkName: 'import-user' */ './views/User.vue')
  },
  {
    path: '/import/admin',
    name: 'Import Tracks Admin',
    component: () =>
      import(/* webpackChunkName: 'import-admin' */ './views/Admin.vue')
  }
]
